// removed by extract-text-webpack-plugin
module.exports = {"header":"Dialog__header","body":"Dialog__body","footer":"Dialog__footer"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Dialog/Dialog.tablet.css
// module id = 1140
// module chunks = 8